import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  asbestosFacilities: "AsbestosFacility.AsbestosFacilities",
  list: "AsbestosFacility.AsbestosFacilityList",
  new: "AsbestosFacility.AsbestosFacilityNew",
  base: "AsbestosFacility.AsbestosFacilityBase",
  view: "AsbestosFacility.AsbestosFacilityView",
  edit: "AsbestosFacility.AsbestosFacilityEdit",
  complaints: "AsbestosFacility.AsbestosFacilityComplaints",
  complaintInvestigationsChildList: "AsbestosFacility.ComplaintInvestigationsChildList",
  enforcementActions: "AsbestosFacility.AsbestosFacilityEnforcementActions",
  documents: "AsbestosFacility.AsbestosFacilityDocuments",
  documentsEdit: "AsbestosFacility.AsbestosFacilityDocumentsEdit",
  documentsNew: "AsbestosFacility.AsbestosFacilityDocumentsNew",
  notes: "AsbestosFacility.AsbestosFacilityNotes",
  noteEdit: "AsbestosFacility.AsbestosFacilityNoteEdit",
  noteNew: "AsbestosFacility.AsbestosFacilityNoteNew",
  audit: "AsbestosFacility.AsbestosFacilityAudit",
};

export { names as asbestosFacilityRouteNames };

const asbestosFacilityRoutes: RouterOptions["routes"] = [
  {
    path: "/asbestosFacility",
    name: names.asbestosFacilities,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Asbestos Facilities" },
        component: () => import("@/views/asbestosFacility/AsbestosFacilityList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/asbestosFacility/AsbestosFacilityBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Asbestos Facility", isNew: true },
            component: () => import("@/views/asbestosFacility/AsbestosFacilityEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/asbestosFacility/AsbestosFacilityBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Asbestos Facility View" },
            component: () => import("@/views/asbestosFacility/AsbestosFacilityView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Asbestos Facility Edit", isForm: true },
            component: () => import("@/views/asbestosFacility/AsbestosFacilityEdit.vue"),
          },
          {
            path: "complaints",
            name: names.complaints,
            meta: { title: "Asbestos Facility Complaints" },
            component: () => import("@/views/asbestosFacility/ComplaintChildList.vue"),
          },
          {
            path: "investigations",
            name: names.complaintInvestigationsChildList,
            meta: { title: "Investigations" },
            component: () => import("@/views/asbestosFacility/InvestigationChildList.vue"),
          },
          {
            path: "enforcementActions",
            name: names.enforcementActions,
            meta: { title: "Asbestos Enforcement Actions" },
            component: () => import("@/views/asbestosFacility/EnforcementActionChildList.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Asbestos Facility Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="asbestosFacility" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Asbestos Facility Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="asbestosFacility" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Asbestos Facility Documents", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="asbestosFacility" />,
            },
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Asbestos Facility Notes" },
            component: {
              render: () => (
                <EntityNotes idField="asbestosFacilityId" routeNamePrefix="AsbestosFacility.AsbestosFacilityNote" />
              ),
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Asbestos Facility Note", isForm: true },
            component: () => import("@/views/asbestosFacility/AsbestosFacilityNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Asbestos Facility Note", isForm: true },
            component: () => import("@/views/asbestosFacility/AsbestosFacilityNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Asbestos Facility Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="AsbestosFacility" />,
            },
          },
        ],
      },
    ],
  },
];
export default asbestosFacilityRoutes;
